import { Avatar, styled } from '@mui/material';

export const AvatarHeader = styled(Avatar)`
  width: 35px;
  height: 35px;
  background-color: ${({ theme }) => theme.palette.custom.avatar};
  color: ${({ theme }) => theme.palette.text.primary};
`;
